export default __webpack_public_path__ + "static/media/passwordgeneratorpic.1409b8cc.png";